type Config = {
    mouseShare: boolean;
};

export const config: Config = {
    mouseShare: true,
};
